import axios from 'axios'
import { constructTemplates } from '@/views/autopilot/templates'

import type { LegacyTemplate } from '@/views/autopilot/templates'

export default function useLegacyTemplates({ legacyMarketingFlows }) {
  const legacyTemplates = ref<LegacyTemplate[]>([])

  const triggerNames = computed(() => {
    return legacyMarketingFlows.value
      .map((flow) => {
        return flow.legacy_trigger
      })
      .filter((trigger) => trigger !== null)
  })

  const fetchAutopilotTemplates = async () => {
    const { data } = await axios.get('/autopilot-templates')
    legacyTemplates.value = data.data
  }

  const formattedLegacyTemplates = computed(() => {
    legacyTemplates.value = legacyTemplates.value.filter((template) => !triggerNames.value.includes(template.trigger))
    return constructTemplates({ templates: legacyTemplates.value, isLegacy: true })
  })

  onMounted(async () => {
    await fetchAutopilotTemplates()
  })

  return {
    formattedLegacyTemplates
  }
}
